// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cart_cartSection__SjC7C {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    gap: 24px;
    background: var(--color-neutral-200);
    padding: 16px;
    border: 1px solid var(--color-black);
    border-radius: var(--radius-large);
    -webkit-border-radius: var(--radius-large);
    -moz-border-radius: var(--radius-large);
    -ms-border-radius: var(--radius-large);
    -o-border-radius: var(--radius-large);
}


.Cart_cartSection2__cNT5h {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    background: var(--color-neutral-000);
    padding: 16px;
    border: 1px solid var(--color-black);
    border-radius: var(--radius-large);
    -webkit-border-radius: var(--radius-large);
    -moz-border-radius: var(--radius-large);
    -ms-border-radius: var(--radius-large);
    -o-border-radius: var(--radius-large);
}

.Cart_cartItem__prvjY,
.Cart_cartInfo__YwCTw {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}


.Cart_cartHeader__NeIE8 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px 0;
    border-bottom: 4px solid var(--color-primary);
}

.Cart_accordion_item_img__S1NO1 {
    width: 100%;
    height: 140px;
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
    overflow: hidden;
}

.Cart_accordion_item_img__S1NO1>img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: auto;
}


.Cart_cartAddressInfo__vPdNt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    background-color: var(--color-neutral-200);
    border: 1px solid var(--color-neutral-900);
    border-radius: var(--radius-global);
    padding: 8px;
}

.Cart_cartAddressInfoItem__iZptE {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--color-neutral-900);
    font-weight: 600;
    font-size: 0.9rem;
}

.Cart_cartAddressInfoItem_2__5tLjA {
    width: 100%;
    max-width: 400px;
}

.Cart_cartAddressInfoItem_2__5tLjA textarea {
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    max-height: 150px;
}

.Cart_cartAddressInfo__vPdNt p {
    font-size: 0.9rem;
    color: var(--color-neutral-600);
    font-weight: 400;
}

.Cart_cartInfoMessage__JpT1W {
    display: flex;
    gap: 8px;
    color: #5F82FF;
    font-size: 0.9rem;
    margin: 16px 0;
}

.Cart_cartInfoMessage__JpT1W svg {
    width: 24px;
    height: 24px;
}

.Cart_readOnlyStateInput__Wf2h4{
    border: solid 1px var(--color-neutral-900);
    padding: 8px;
    margin-top: 4px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
}


@media screen and (min-width: 992px) {
    .Cart_cartSection__SjC7C {
        padding: 40px;
    }

    .Cart_cartItem__prvjY {
        width: calc(100% - 416px);
    }

    .Cart_cartInfo__YwCTw {
        width: 400px;
    }

}

.Cart_test__8Ed1S{
    height: 200px;
    overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Cart.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,oCAAoC;IACpC,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,oCAAoC;IACpC,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,0CAA0C;IAC1C,0CAA0C;IAC1C,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;AAEJ;;AAEA;IACI,aAAa;IACb,cAAc;AAClB","sourcesContent":[".cartSection {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    gap: 24px;\n    background: var(--color-neutral-200);\n    padding: 16px;\n    border: 1px solid var(--color-black);\n    border-radius: var(--radius-large);\n    -webkit-border-radius: var(--radius-large);\n    -moz-border-radius: var(--radius-large);\n    -ms-border-radius: var(--radius-large);\n    -o-border-radius: var(--radius-large);\n}\n\n\n.cartSection2 {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    background: var(--color-neutral-000);\n    padding: 16px;\n    border: 1px solid var(--color-black);\n    border-radius: var(--radius-large);\n    -webkit-border-radius: var(--radius-large);\n    -moz-border-radius: var(--radius-large);\n    -ms-border-radius: var(--radius-large);\n    -o-border-radius: var(--radius-large);\n}\n\n.cartItem,\n.cartInfo {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n\n.cartHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 16px 0;\n    border-bottom: 4px solid var(--color-primary);\n}\n\n.accordion_item_img {\n    width: 100%;\n    height: 140px;\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n    overflow: hidden;\n}\n\n.accordion_item_img>img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    margin: auto;\n}\n\n\n.cartAddressInfo {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 20px;\n    background-color: var(--color-neutral-200);\n    border: 1px solid var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    padding: 8px;\n}\n\n.cartAddressInfoItem {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    color: var(--color-neutral-900);\n    font-weight: 600;\n    font-size: 0.9rem;\n}\n\n.cartAddressInfoItem_2 {\n    width: 100%;\n    max-width: 400px;\n}\n\n.cartAddressInfoItem_2 textarea {\n    width: 100%;\n    height: fit-content;\n    max-height: 150px;\n}\n\n.cartAddressInfo p {\n    font-size: 0.9rem;\n    color: var(--color-neutral-600);\n    font-weight: 400;\n}\n\n.cartInfoMessage {\n    display: flex;\n    gap: 8px;\n    color: #5F82FF;\n    font-size: 0.9rem;\n    margin: 16px 0;\n}\n\n.cartInfoMessage svg {\n    width: 24px;\n    height: 24px;\n}\n\n.readOnlyStateInput{\n    border: solid 1px var(--color-neutral-900);\n    padding: 8px;\n    margin-top: 4px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n}\n\n\n@media screen and (min-width: 992px) {\n    .cartSection {\n        padding: 40px;\n    }\n\n    .cartItem {\n        width: calc(100% - 416px);\n    }\n\n    .cartInfo {\n        width: 400px;\n    }\n\n}\n\n.test{\n    height: 200px;\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cartSection": `Cart_cartSection__SjC7C`,
	"cartSection2": `Cart_cartSection2__cNT5h`,
	"cartItem": `Cart_cartItem__prvjY`,
	"cartInfo": `Cart_cartInfo__YwCTw`,
	"cartHeader": `Cart_cartHeader__NeIE8`,
	"accordion_item_img": `Cart_accordion_item_img__S1NO1`,
	"cartAddressInfo": `Cart_cartAddressInfo__vPdNt`,
	"cartAddressInfoItem": `Cart_cartAddressInfoItem__iZptE`,
	"cartAddressInfoItem_2": `Cart_cartAddressInfoItem_2__5tLjA`,
	"cartInfoMessage": `Cart_cartInfoMessage__JpT1W`,
	"readOnlyStateInput": `Cart_readOnlyStateInput__Wf2h4`,
	"test": `Cart_test__8Ed1S`
};
export default ___CSS_LOADER_EXPORT___;
